import React from "react";
import { Navigate } from "react-router-dom";
import { useStore } from "@/context/StoreContext";

const AdminRoute = ({ children }) => {
  const { user, authLoading, isAdmin } = useStore();

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="overline">Loading…</p>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AdminRoute;
